export class LaborCategory {
  Id?: number;
  RecordId?: number;
  CreatedBy: number;
  CreatedDate: string;
  EmployeeNumber: string;
  EndDate: Date;
  FullName: string;
  IsActive: boolean;
  IsArchived: boolean;
  IsDeleted: boolean;
  ModifiedBy: number;
  ModifiedDate: string;
  Name: string;
  Number: string;
  OrganizationId: number;
  ProjectId: number;
  Rate: number;
  StartDate: Date;

  constructor(obj?: Partial<LaborCategory>) {
    if (obj) {
      Object.assign(this, obj);
    } else {
      throw Error('Object cannot be null');
    }
  }

  get NameAndNumber(): string {
    if (this.EmployeeNumber) {
      return this.Name + ' (' + this.EmployeeNumber + '-' + this.FullName + ')';
    }
    else {
      return this.Name + ' (' + this.Number + ')';
    }
  }
}
